import { Component, OnInit, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { S3Service, CognitoCallback } from '../service/s3.service';
import { environment } from "../../environments/environment";
import { Observable } from 'rxjs/Observable';
import { S3Object } from '../shared/S3Object'
import { Folder } from '../shared/folder'
import { File } from '../shared/file'
import { S3Folder } from '../shared/S3Folder';
import { MatDialog, MatDialogRef, MatListModule } from '@angular/material';
import { AddFolderDialogComponent } from './addFolderDialog.component';
import { Router } from "@angular/router";
import { DialogsService } from '../service/dialogs.service';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-memos',
  templateUrl: './memos.component.html',
  styleUrls: ['./memos.component.css']
})
export class MemosComponent implements OnInit, CognitoCallback {

  folder: Folder = {
    name: null,
    folders: [],
    files: []
  }
  userGroup: string = '';
  selectedIndex: number = null;
  isAuthenticated : boolean = false;
  folderTable: string[] = [];
  loading = false;
  errorMessage: string;

  selectedFolder: Folder = {
    name: null,
    folders: [],
    files: []
  }
  selectedFile: any = null;
  fileToUpload: any = null;

  selectedOptions: any[] = [];

  constructor(private dialogsService: DialogsService, private viewContainerRef: ViewContainerRef,
    public s3Service: S3Service, public dialog: MatDialog, private authService: AuthService ) { }

  ngOnInit() {
    // this.s3Service.viewAlbum(this);
    this.folderTable.push('isojoen metsästysseura/');

    this.authService.userGroup.subscribe((userGroup) => {
      this.userGroup = userGroup;
      console.log('MemosComponent userGroup: ',this.userGroup);
    });
    this.authService.authStatusChanged.subscribe((authenticated) => {
      this.isAuthenticated = authenticated;
      if (authenticated) {
        console.log('MemosComponent authenticated!');
      } else {
        console.log('MemosComponent not authenticated!');
      }
    });
    this.authService.isAuthenticated().subscribe((result:boolean) => {
      console.log('MemosComponent isAuthenticated:', result);
      this.isAuthenticated = result;
      this.loading = true;
      this.s3Service.listAlbums(this);
    });
    
  }

  deleteFolder(folder, index) {
    console.log('deleteFolder() folder:', folder);
    console.log('deleteFolder()  this.folderTable:', this.folderTable);
    this.showConfirm('hakemistoa', folder).subscribe(result => {
      if (result) {
        if (this.folderTable.length == 1) {
          this.loading = true;
          this.s3Service.deleteAlbum(folder, this);
        }
        else {
          let folderToDelete = '';
          for (var i = 1; i < this.folderTable.length; i++) {
            folderToDelete = folderToDelete + this.folderTable[i];
          }
          this.loading = true;
          this.s3Service.deleteAlbum(folderToDelete + folder, this);
        }
      }
      else {
        console.log('delete canceled');
      }
    });

  }

  deleteFiles() {
    console.log('deleteFiles()', this.selectedOptions);
    let filesToDelete: string[] = [];
    let path: string = '';
    if (this.folderTable.length == 1) {

    }
    else {
      for (var i = 1; i < this.folderTable.length; i++) {
        path = path + this.folderTable[i];
      }
    }
    for (var i = 0; i < this.selectedOptions.length; i++) {
      filesToDelete.push(path + this.selectedOptions[i].name);
    }
    console.log('deleteFiles() filesToDelete', filesToDelete);

    this.loading = true;
    this.s3Service.deletePhotos(filesToDelete, this);
  }

  deletePhotosCallback(message: string, data: any) {
    console.log('deletePhotosCallback()');
    let path: string = '';
    if (message != null) {
      this.loading = false;
      console.log('deletePhotosCallback() error message:', message);
      alert('Tiedoston poisto epäonnistui: ' + message);
    }
    else {
      this.selectedOptions = [];
      console.log('deletePhotosCallback() data:', data);
      if (this.folderTable.length == 1) {
      }
      else {
        for (var i = 1; i < this.folderTable.length; i++) {
          path = path + this.folderTable[i];
        }
      }
      console.log('deletePhotosCallback() path:', path);
      this.s3Service.viewAlbum(path, environment.rekognitionBucket, this);
      //this.s3Service.listAlbums(this);
    }
  }

  onNgModelChange(event) {
    console.log('onNgModelChange', event);
    console.log('onNgModelChange() ', this.folderTable);
  }

  downloadFiles() {
    let path = '';
    if (this.folderTable.length == 1) {

    }
    else {
      for (var i = 1; i < this.folderTable.length; i++) {
        path = path + this.folderTable[i];
      }
    }
    for (var i = 0; i < this.selectedOptions.length; i++) {
      this.s3Service.downloadFile(path + this.selectedOptions[i].name, this);
    }

  }

  downloadFileCallback(message: string, url: any) {
    if (message != null) {
      this.loading = false;
      console.log('downloadFileCallback() error message:', message);
      alert('Tiedoston haku epäonnistui: ' + message);
    }
    else {
      console.log('downloadFileCallback()', url);
      this.selectedOptions = [];

    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    console.log('this.fileToUpload: ', this.fileToUpload);
    let folder = '';
    if (this.folderTable.length == 1) {

    }
    else {
      for (var i = 1; i < this.folderTable.length; i++) {
        folder = folder + this.folderTable[i];
      }
      console.log('folder: ', folder);
    }
    this.loading = true;
    this.s3Service.addPhoto(folder, this.fileToUpload, this);
  }

  addFileCallback(message: string, data: any) {
    let path = '';
    if (message != null) {
      this.loading = false;
      console.log('addFileCallback() error message:', message);
      alert('Tiedoston siirto epäonnistui: ' + message);
    }
    else {
      console.log('addFileCallback()');
      if (this.folderTable.length == 1) {
      }
      else {
        for (var i = 1; i < this.folderTable.length; i++) {
          path = path + this.folderTable[i];
        }
      }
      console.log('addFileCallback() path:', path);
      this.s3Service.viewAlbum(path, environment.rekognitionBucket,this);
    }

  }

  DeleteAlbumCallback(message: string, data: any) {

    if (message != null) {
      this.loading = false;
      console.log('DeleteAlbumCallback() error message:', message);
      alert('Hakemiston poisto epäonnistui: ' + message);
    }
    else {
      console.log('DeleteAlbumCallback() data:', data);
      let folderToSearch = '';
      if (this.folderTable.length == 1) {
      }
      else {
        for (var i = 1; i < this.folderTable.length; i++) {
          folderToSearch = folderToSearch + this.folderTable[i];
        }
      }

      this.s3Service.viewBreadCrumbFolder(folderToSearch, this);

    }
  }

  showConfirm(type: string, name: string): Observable<boolean> {
    return this.dialogsService.confirm('Olet poistamassa ' + type + ' ' + name, 'Oletko varma?', this.viewContainerRef);
  }

  addFolder() {
    console.log('addFolder()');
    let dialogRef = this.dialog.open(AddFolderDialogComponent, {
      data: { errorMessage: this.errorMessage },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;
        console.log('result: ' + result);

        if (this.folderTable.length == 1) {
          this.s3Service.createAlbum(result, this);
        }
        else {
          let folderToAdd = '';
          for (var i = 1; i < this.folderTable.length; i++) {
            folderToAdd = folderToAdd + this.folderTable[i];
          }

          this.s3Service.createAlbum(folderToAdd + result, this);
        }


      }
      else {
        console.log('result: ' + result);
      }
    });

  }

  CreateAlbumCallback(message: string, data: any) {
    if (message != null) {
      this.loading = false;
      console.log('CreateAlbumCallback virhe:' + message);

    } else {
      console.log('CreateAlbumCallback folder:', data);
      let folderToSearch = '';
      if (this.folderTable.length == 1) {
      }
      else {
        for (var i = 1; i < this.folderTable.length; i++) {
          folderToSearch = folderToSearch + this.folderTable[i];
        }
      }

      this.s3Service.viewBreadCrumbFolder(folderToSearch, this);
    }
  }

  viewBreadCrumbFolder(folder, index) {
    console.log('viewBreadCrumbFolder() folder:', folder);
    console.log('viewBreadCrumbFolder() index:', index);
    let folderToSearch = '';
    if (folder === 'isojoen metsästysseura/') {

    }
    else {
      for (var i = 1; i <= index; i++) {
        folderToSearch = folderToSearch + this.folderTable[i];
      }
    }
    this.folderTable.splice(index + 1, this.folderTable.length);

    // this.selectedFolder.name = folderToSearch;
    if (folder === 'isojoen metsästysseura/') {
      folder = '';
    }
    this.loading = true;
    this.s3Service.viewBreadCrumbFolder(folderToSearch, this);
  }

  viewFolder(folder, index) {
    console.log('viewFolder() folder:', folder);
    console.log('viewFolder()  this.folderTable:', this.folderTable);


    this.selectedFolder = folder;
    this.selectedIndex = index;
    let path = ''
    for (var i = 1; i < this.folderTable.length; i++) {

      path = path + this.folderTable[i];
    }

    this.folderTable.push(folder + '/')
    this.loading = true;
    this.s3Service.viewAlbum(path + folder + '/', environment.rekognitionBucket, this);
    // }




  }


  viewSubFolder(folder, i, x) {
    console.log('viewSubFolder() folder:', folder);
    console.log('viewSubFolder() i:', i);
    console.log('viewSubFolder() x:', x);
  }

  viewBreadCrumbFolderCallBack(message: string, folder: Folder) {
    this.loading = false;
    if (message != null) {
      console.log('viewBreadCrumbFolderCallBack virhe:' + message);

    } else {
      console.log('viewBreadCrumbFolderCallBack ok: folder:', folder);
      for (var i = 0; i < folder.folders.length; i++) {
        let folderName = folder.folders[i].split("/");
        console.log('folderName: ', folderName);
        console.log('folderName.length:', folderName.length);
        folder.folders[i] = folderName[folderName.length - 2];
        console.log('folder.folders[i]: ', folder.folders[i]);
      }
      this.folder = folder;

    }
  }



  cognitoCallback(message: string, folder: Folder) {
    this.loading = false;

    if (message != null) {
      console.log('cognitoCallback virhe:' + message);

    } else {

      console.log('cognitoCallback ok: folder:', folder);
      console.log('this.selectedIndex:', this.selectedIndex);
      for (var i = 0; i < folder.folders.length; i++) {
        let folderName = folder.folders[i].split("/");
        console.log('folderName: ', folderName);
        console.log('folderName.length:', folderName.length);
        for (var x = 0; x < folderName.length; x++) {
          if (folderName[x] === "" || folderName[x] === this.selectedFolder.name) {

          }
          else {
            folder.folders[i] = folderName[x];
            console.log('folder.folders[i]: ', folder.folders[i]);

            //this.folder.folders[this.selectedIndex].folders.push(folder.folders[i])
            console.log('this.folder.folders[this.selectedIndex] ', this.folder.folders[this.selectedIndex]);
          }

        }
      }
      this.folder = folder;

    }
  }
  cognitoCallback1(message: string, album: Folder) {
    this.loading = false;
    if (message != null) {
      console.log('cognitoCallback virhe:' + message);

    }
    else {
      this.folder = album;
      console.log('cognitoCallback1() album:', album);
      for (var i = 0; i < album.files.length; i++) {
        if (album.files[i].type === 'folder') {
          this.folderTable.push(album.files[i].name);
          break;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/memos/memos.component.ts